<template>
<div class="login-bottom">
  <div>
    <p class="login-bottom-text" v-html="$t('login.professional_consultant')"></p>
    <span>{{ $t('common.support') }} / {{ $t('common.tel') }}</span>
  </div>
</div>
</template>

<script>
/* 2021.04.13 - Nam Sang Woo
 * app-login-bottom 컴포넌트 
 * description: 추후 공통적으로 쓰일 것으로 예상되어 만들어 놨습니다.
 */ 
export default {
	name: "appLoginBottom",
};
</script>

<style lang="scss" scoped>
.login-bottom {
    width: 100%;
    margin-top: 28px;
    font-size: 13px;
    line-height: 1.67;
    color: #6E7C89;
    text-align: center;
    font-weight: 300;

    p{
      margin:0;
      font-weight: 300;
    }
}
</style>